import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-ville-lien',
    templateUrl: './ville-lien.component.html',
    styleUrls: ['./ville-lien.component.scss']
})
export class VilleLienComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
